/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createAbs } from '../../factoriesNumber.js';
export var absDependencies = {
  typedDependencies,
  createAbs
};